import { ToolSet } from './toolSet.model';
import { Tool } from './tool.model';
/**
 * Quick fix class to handle the problem with sending this object
 * {
 *   tools: []
 *   sets: []
 * }
 * instead of actual entity
 */
class GroupChildWrapper {

    public tools: Tool[];
    public sets: ToolSet[];

    constructor(object: any = {}, parent?: any) {
        if (object.tools) {
            this.tools = object.tools.map(tool => new Tool(tool, parent));
        }
        if (object.sets) {
            this.sets = object.sets.map(toolSet => new ToolSet(toolSet, parent));
        }
    }

    get item() {
        if (this.tools) {
            return this.tools[0];
        }
        return this.sets[0];
    }
}

export { GroupChildWrapper };
